export const WASH_TYPE_LABELS = {
  BASIC: "Basic",
  STANDARD: "Standard",
  PREMIUM: "Premium",
  LUXURY: "Luxury",
  RUBBING: "Rubbing",
  RUBBINGCOATING: "Rubbing & Coating",
  WATERREPELLENT: "Water Repellent",
  PREMIUMPLUS: "Premium Plus",
  LUXURYPLUS: "Luxury Plus",
  PREMIUMHYBRIDCERMARICCOAT: "Premium Hybrid Ceramic Coat",
  BASICHYBRIDCERMARICCOAT: "Coat",
  BASICINTERIOR: "Basic Interior Cleaning",
  PREMIUMINTERIOR: "Premium Interior",
  PREMIUMPLUSINTERIOR: "Premium Plus Interior",
  LUXURYINTERIOR: "Luxury Interior",
};

export const VEHICLE_WASH_TYPE_OPTIONS = {
  CAR: [
    "BASIC",
    "STANDARD",
    "PREMIUM",
    "PREMIUMPLUS",
    "LUXURY",
    "LUXURYPLUS",
    "RUBBING",
    "RUBBINGCOATING",
    "WATERREPELLENT",
    "PREMIUMHYBRIDCERMARICCOAT",
    "BASICHYBRIDCERMARICCOAT",
    "BASICINTERIOR",
    "PREMIUMINTERIOR",
    "PREMIUMPLUSINTERIOR",
    "LUXURYINTERIOR",
  ],
  BIKE: [
    "STANDARD",
    "PREMIUM",
    "RUBBINGCOATING",
    "PREMIUMHYBRIDCERMARICCOAT",
  ],
};

export const DEFAULT_WASH_TYPE = "PREMIUM";

const normalizePart = (value) =>
  (value || "").toString().trim().toUpperCase();

export const formatWashTypeKey = (washCode, vehicle) => {
  const washPart = normalizePart(washCode);
  const vehiclePart = normalizePart(vehicle);
  const parts = [washPart];
  if (vehiclePart) {
    parts.push(vehiclePart);
  }
  return parts.join("_");
};

export const extractWashCode = (washTypeKey) => {
  if (!washTypeKey) return null;
  const parts = washTypeKey.split("_");
  return parts[0] || null;
};

export const extractVehicleFromWashType = (washTypeKey) => {
  if (!washTypeKey) return null;
  const parts = washTypeKey.split("_");
  return parts.length >= 2 ? parts[1] : null;
};

export const extractSeaterFromWashType = (washTypeKey) => {
  if (!washTypeKey) return null;
  const parts = washTypeKey.split("_");
  return parts.length > 2 ? parts.slice(2).join("_") : null;
};

export const getWashTypeLabel = (washTypeKey) => {
  if (!washTypeKey) return "";
  const code = extractWashCode(washTypeKey);
  const normalizedCode = normalizePart(code);
  return (
    WASH_TYPE_LABELS[normalizedCode] ||
    WASH_TYPE_LABELS[code] ||
    WASH_TYPE_LABELS[normalizePart(washTypeKey)] ||
    code ||
    washTypeKey
  );
};


